import * as stylex from '@stylexjs/stylex';

//MEDIA QUERY CONSTANTS
export const PREFERS = {
  DARK: '@media (prefers-color-scheme: dark)',
  REDUCED_MOTION: '@media (prefers-reduced-motion)'
};

//VIEWPORT QUERY CONSTANTS
export const VP = {
  MOBILE: "@media (min-width: 350px)",
  TABLET: "@media (min-width: 580px)",
  DESKTOP_S: "@media (min-width: 960px)",
  DESKTOP_M: "@media (min-width: 1260px)",
  DESKTOP_L: "@media (min-width: 1560px)"
};
export const POINTER = {
  MOUSE: "@media (hover: hover) and (pointer: fine)",
  TOUCH: "@media (hover: none) and (pointer: coarse)"
};
export const color = {
  surfaceBasePrimary: "#ffffff",
  surfaceBaseSecondary: "#fcfcff",
  surfaceBaseQuoteBg: "#f1f4f7",
  surfaceBaseBackground: "#eef1f6",
  surfaceDarkBackground: "#0e1331",
  surfaceBaseTertiary: "#d9dce4",
  surfaceBrandOnLightPrimary: "#001d47",
  surfaceBrandOnLightSecondary: "#002e72",
  surfaceBrandOnDarkSecondary: "#dae9ff",
  surfaceBrandOnDarkPrimary: "#f8fbff",
  interactivePrimaryBackgroundDefault: "linear-gradient(120deg, #ff2828 0%, #f8510a 100%)",
  interactivePrimaryBackgroundHover: "linear-gradient(120deg, #ff2828 0%, #f8510a 100%)",
  interactivePrimaryBackgroundPressed: "linear-gradient(120deg, #d20909 0%, #cd3e00 100%)",
  interactivePrimaryLabel: "#fff",
  interactivePrimaryBorder: "#cd3e00",
  interactivePrimaryHover: "#D20909",
  interactiveSecondaryBorder: "#ffad8a",
  interactiveSecondaryBackgroundDefault: "#ffc8a9",
  interactiveSecondaryBackgroundHover: "#ffe1d0",
  interactiveSecondaryBackgroundPressed: "#ffad8a",
  interactiveSecondaryLabel: "#3c1200",
  typographyBrandOnLightPrimaryHeading: "#001d47",
  typographyBrandOnLightLabel: "#0045ab",
  typographyBrandOnDarkPrimaryHeading: "#f8fbff",
  typographyBrandOnDarkSecondaryHeading: "#afcfff",
  typographyDefaultOnLightPrimaryHeading: "#1d1e26",
  typographyDefaultOnLightSecondaryHeading: "#2d2d38",
  typographyDefaultOnLightBody: "#41414f",
  typographyDefaultOnDarkPrimaryHeading: "#ffffff",
  typographyDefaultOnDarkSecondaryHeading: "#eef1f6",
  typographyDefaultOnDarkBody: "#dcdfe8",
  typographyCriticalLabel: "#d20909",
  typographySuccessLabel: "#08711d",
  primaryOnLightTextShadow: "rgba(92, 28, 0, 0.8)",
  success50: "#F4FCF6",
  success100: "#DDF2E1",
  success200: "#B9E9C3",
  success300: "#7ED890",
  success400: "#41B057",
  success500: "#0F860F",
  success600: "#08711D",
  success700: "#095A19",
  success800: "#05320E",
  success900: "#04260c",
  interactiveSuccessBackgroundDefault: "linear-gradient(120deg, #08711D 0%, #0F860F 100%)",
  interactiveSuccessBackgroundHover: "linear-gradient(120deg, #0F860F 0%, #41B057 100%)",
  interactiveSuccessBackgroundPressed: "linear-gradient(120deg, #095A19 0%, #08711D 100%)"
};
export const iconColor = {
  primaryGold: "var(--xv3rmu7)",
  primaryGreen: "var(--xqlsi55)",
  brandLight: "var(--xheymfb)",
  brandDark: "var(--xn4dyn0)",
  neutralDark: "var(--x120u6gn)",
  brandLighter: "var(--x13fosn6)",
  frameBg: "var(--x1iep96g)",
  backgroundTint: "var(--xc5pzxg)",
  __varGroupHash__: "xcnnspb"
};
export const typographyColor = {
  brandPrimaryHeading: "var(--x51zkyk)",
  brandSecondaryHeading: "var(--x1lpx4a2)",
  brandLabel: "var(--x32c4gx)",
  neutralPrimaryHeading: "var(--x14e4a3m)",
  neutralSecondaryHeading: "var(--xixr5p9)",
  neutralBase: "var(--x1dkurqu)",
  neutralDarkTint: "var(--xtdf5p8)",
  criticalLabel: "var(--xp1grio)",
  successLabel: "var(--xpphe09)",
  nakedInlineButtonBackground: "var(--x9hee85)",
  action: "var(--xo4hcoq)",
  actionBackground: "var(--x1qercb7)",
  "--input_root": "var(--input_root)",
  "--critical": "var(--critical)",
  __varGroupHash__: "x13z61aa"
};
export const border = {
  surface_neutral10: "var(--x85mh15)",
  surface_neutral10Color: "var(--x1xpk2v6)",
  primary: "var(--xz2vimm)",
  secondary: "var(--x1uzjbfo)",
  focusRing: "var(--x1rmbekc)",
  __varGroupHash__: "x1rr2esq"
};
export const shadow = {
  primaryOnLightTextShadow: "var(--x4k2meq)",
  primaryOnLightSurfaceShadow: "var(--x1uurpeo)",
  primaryOnDarkTextShadow: "var(--x125k17l)",
  neutral10: "var(--x3ia25o)",
  neutral20: "var(--xzhj6vc)",
  neutral30: "var(--x1dowe23)",
  neutral900: "var(--x1c9robd)",
  elevationNeutralOnLight10: "var(--xqscf3c)",
  elevationNeutralOnLight20: "var(--xekmy1i)",
  elevationNeutralOnLight30: "var(--x1yem6a1)",
  interactivePrimarySurfaceOnLight: "var(--x10nmw0n)",
  interactivePrimaryTextOnLight: "var(--x1827ov7)",
  interactivePrimaryTextOnDark: "var(--x1f66oz7)",
  mediaOverlayLarge: "var(--xmah6ef)",
  mediaOverlaySmall: "var(--xltf645)",
  textShadowPrimaryOnLight: "var(--x12ddrab)",
  textShadowPrimaryOnDark: "var(--xmms1qo)",
  input: "var(--x1u4ca2h)",
  __varGroupHash__: "x1u14row"
};
export const size = {
  "0": "var(--x18uqhg2)",
  "1": "var(--xrebb66)",
  "2": "var(--xzo99ic)",
  "5": "var(--x1bijqma)",
  "10": "var(--x1o2986w)",
  "15": "var(--x4hqd6j)",
  "20": "var(--x1mlw9el)",
  "30": "var(--x1lecmy3)",
  "40": "var(--xpl4m8n)",
  "45": "var(--x18rp3ou)",
  "50": "var(--xvjbtx7)",
  "60": "var(--x10irai8)",
  "70": "var(--x2383me)",
  "80": "var(--x673vhd)",
  "90": "var(--xdaqbff)",
  "100": "var(--x1erxije)",
  contentMaxWidth: "var(--xptwy4e)",
  __varGroupHash__: "xjw7vcr"
};
export const columnWidth = {
  xxSmallColumn: "var(--xsjf8jg)",
  xSmallColumn: "var(--x1gy1ey9)",
  smallColumn: "var(--xoltew7)",
  mediumColumn: "var(--x11arjy3)",
  largeColumn: "var(--x17gpfop)",
  xLargeColumn: "var(--x1tjdoyo)",
  __varGroupHash__: "x1vxaurm"
};
export const fontSizes = {
  small: "var(--xj4t6x1)",
  body: "var(--x7mm5pa)",
  fs60: "var(--x19d5lls)",
  fs70: "var(--xjxu0wt)",
  fs80: "var(--x1c8ue0u)",
  fs90: "var(--x1ueoilk)",
  fs100: "var(--xtoypx7)",
  __varGroupHash__: "xgx9f49"
};
export const spacing = {
  gap_none: "var(--xcj2fg7)",
  gap_xsm: "var(--xe81na7)",
  gap_sml: "var(--xooq9b9)",
  gap_med: "var(--xt7chwy)",
  gap_lrg: "var(--x1t2ib6e)",
  gap_xl: "var(--xs0bzu2)",
  elementSpacingInline: "var(--x163tju8)",
  elementSpacingInlineCompact: "var(--xngayom)",
  elementSpacingInlineXS: "var(--x1xkru65)",
  elementPaddingXS: "var(--xqjg388)",
  elementPaddingSml: "var(--x6o2xxl)",
  elementPaddingReg: "var(--x13ou6sd)",
  elementPaddingLrg: "var(--x1t5re9r)",
  inset_none: "var(--x1x7l1vc)",
  inset_xxxs: "var(--x1ll5ac3)",
  inset_xxs: "var(--xszsufh)",
  inset_xs: "var(--xwmuidz)",
  inset_sml: "var(--x1heb7u7)",
  inset_med: "var(--x14u38ia)",
  inset_lrg: "var(--x18ixd67)",
  verticalRhythmXSmall: "var(--xvuln5a)",
  verticalRhythmSmall: "var(--x1370s54)",
  verticalRhythmMedium: "var(--xlp0bit)",
  verticalRhythmLarge: "var(--x1b38i40)",
  __varGroupHash__: "xja9c04"
};
export const negativeSpacing = {
  gap_none: "var(--x1lu4oec)",
  gap_xsm: "var(--xqnqp5e)",
  gap_sml: "var(--x23tsob)",
  gap_med: "var(--x133bbq4)",
  gap_lrg: "var(--x1agep3c)",
  gap_xl: "var(--xiocgs)",
  elementSpacingInline: "var(--x1xxsowb)",
  elementSpacingInlineCompact: "var(--xpsemcz)",
  elementSpacingInlineXS: "var(--x1dh3o5a)",
  elementPaddingXS: "var(--xql2pyt)",
  elementPaddingSml: "var(--x1yowzif)",
  elementPaddingReg: "var(--x15mx5lg)",
  elementPaddingLrg: "var(--xpzubub)",
  inset_none: "var(--x1x6xamh)",
  inset_xxxs: "var(--xw29p49)",
  inset_xxs: "var(--x1e00hkf)",
  inset_xs: "var(--x1l6gppf)",
  inset_med: "var(--xgw1e08)",
  inset_lrg: "var(--x1as51wv)",
  verticalRhythmXSmall: "var(--x1d0sy5s)",
  verticalRhythmSmall: "var(--x1mquc4w)",
  verticalRhythmMedium: "var(--x1gh3g2l)",
  verticalRhythmLarge: "var(--x1cq1zld)",
  __varGroupHash__: "xaaor5x"
};
export const layoutTokens = {
  viewportPadding: "var(--x1c6qqu9)",
  __varGroupHash__: "x1q0gvhk"
};
export const logo = {
  leafColor: "var(--xc83eho)",
  textFillOnLight: "var(--x1qfdlxq)",
  textFillOnDark: "var(--x12o3cc1)",
  heightRegular: "var(--x16u5zwn)",
  heightLarge: "var(--xgvza5h)",
  __varGroupHash__: "x7f0a0x"
};
export const borderRadius = {
  rounded: "var(--xyiqowx)",
  surface_regular: "var(--xwfevev)",
  surface_large: "var(--xl6rwld)",
  element_small: "var(--x1qpik6e)",
  element_xsmall: "var(--x95r9ko)",
  element_regular: "var(--xlg7xi7)",
  element_large: "var(--x50j7xt)",
  __varGroupHash__: "x1tf5s0m"
};
export const fontFamilies = {
  paragraph: "var(--xawatga)",
  heading: "var(--x1cx9eu0)",
  __varGroupHash__: "xhwzdwc"
};
export const fontWeights = {
  bold: "var(--xxndiuq)",
  semibold: "var(--x12bwmfx)",
  regular: "var(--xqo9rs8)",
  __varGroupHash__: "x18k1iy2"
};
export const letterSpacing = {
  xcosy: "var(--x1lrrv4l)",
  cosy: "var(--x1753f2)",
  reg: "var(--x18k0lw3)",
  space: "var(--x16c7hfe)",
  xspace: "var(--x1azjfl2)",
  __varGroupHash__: "xj2155v"
};
export const focus = {
  outlineColor: "var(--x14avve4)",
  outlineWidth: "var(--xw2r0lf)",
  outlineStyle: "var(--x1tzufuz)",
  outlineOffset: "var(--x1cyw2fr)",
  outlineRadius: "var(--x1ymhy9r)",
  __varGroupHash__: "x7u9guv"
};

/* export const buttonColors = stylex.defineVars({
  backgroundColor: {default: 'lightgrey', ':hover': 'gainsboro'},
  textColor: 'grey',
  textShadowColor: null,
  borderColor: null,
}) */

export const button = {
  heightRegular: "var(--xb14m28)",
  inlinePadding: "var(--x1fm9qxu)",
  backgroundPrimary: "var(--xg9d405)",
  backgroundPrimaryHover: "var(--x18ovdu7)",
  backgroundPrimaryPressed: "var(--x15lanu1)",
  backgroundSecondary: "var(--x2assnt)",
  backgroundSecondaryHover: "var(--x18rjg7a)",
  backgroundSecondaryPressed: "var(--xzattgg)",
  borderWidth: "var(--xa68ru)",
  borderColorPrimary: "var(--x1mvnnm9)",
  borderColorSecondary: "var(--xrw5g10)",
  primaryTextColor: "var(--x43y5f4)",
  secondaryTextColor: "var(--x10lw8mx)",
  backgroundIconButton: "var(--xianodp)",
  backgroundIconButtonHover: "var(--xeq7trh)",
  backgroundIconButtonPressed: "var(--x18jh3uz)",
  iconButtonSize: "var(--xe4r67i)",
  uiButtonSize: "var(--xuoi16e)",
  __varGroupHash__: "x1x3fqc6"
};
export const logoHeight = {
  reg: "var(--x14ud3tj)",
  lrg: "var(--xk2zzrg)",
  __varGroupHash__: "x1ao8edn"
};
export const iconFeature = {
  iconSize: "var(--x1k5b61v)",
  __varGroupHash__: "x19yxy06"
};
export const easing = {
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  easeOut: "cubic-bezier(0, 0, 0.2, 1)",
  easeOutBack: "cubic-bezier(0.34, 1.56, 0.64, 1)",
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  easeInBack: "cubic-bezier(0.36, 0, 0.66, -0.56)"
};
export const timing = {
  instant: "50ms",
  rapid: "75ms",
  fast: "150ms",
  normal: "300ms",
  slow: "500ms",
  deliberate: "800ms"
};